<script lang="ts" setup>
const { t } = useI18n();
</script>

<template>
  <UPopover mode="hover" :ui="{ content: 'shadow-none ring-0' }">
    <template #content>
      <div class="p-xs bg-primary-100 max-w-[250px] rounded-lg text-xs font-medium">
        {{ t("product.order-product.tooltip") }}
      </div>
    </template>

    <div class="p-2xs gap-2xs bg-primary-50 hover:bg-primary-100 flex items-center rounded-md">
      <span class="truncate text-xs font-medium text-neutral-500">{{ t("product.order-product") }}</span>
      <UIcon name="i-ph-info" class="text-primary" />
    </div>
  </UPopover>
</template>

<style scoped>

</style>
